import React from 'react';
import { DENTContextProvider } from '../../Services/DENTContext';
import { HealthPlanContextProvider } from '../../../../Services/HealthPlanContext';
import { HealthPlanCode } from '../../../../Enums/HealthPlanCode.enum';
import MeddiDENTHealthPlan from './MeddiDENTHealthPlan';

interface Props {
	patientId: string;
	onHealthPlanCreate: () => void;
}

const MeddiDENT = ({ patientId, onHealthPlanCreate }: Props) => {
	return (
		<HealthPlanContextProvider
			values={{
				healthPlan: { code: HealthPlanCode.DENT },
				setHealthPlan: () => {},
				healthPlanUser: undefined,
				setHealthPlanUser: () => {},
				healthPlanData: null,
				setHealthPlanData: () => {},
				activeHealthPlanUserItem: null,
				setActiveHealthPlanUserItem: () => {},
			}}>
			<DENTContextProvider patientId={patientId}>
				<MeddiDENTHealthPlan
					patientId={patientId}
					onHealthPlanCreate={onHealthPlanCreate}
				/>
			</DENTContextProvider>
		</HealthPlanContextProvider>
	);
};

export default MeddiDENT;
